import { CopyHoverContent } from 'components';
import { Typography } from 'libs/ui';
import { styled } from 'libs/ui/styled';

const TypographyStyled = styled(Typography)(() => ({
  whiteSpace: 'wrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  textWrap: 'wrap',
  display: '-webkit-box',
  wordWrap: 'break-word',
  overflowWrap: 'anywhere',

  '-webkit-line-clamp': '2',
  '-webkit-box-orient': 'vertical',
}));

export const renderTextLineClamp = (
  value: any,
  field?: string,
  title?: string
) => {
  value = field ? value[field] : value;
  if (!value) {
    return null;
  }
  return (
    <CopyHoverContent value={value}>
      <TypographyStyled title={title || value} variant="bodyMedium">
        {value}
      </TypographyStyled>
    </CopyHoverContent>
  );
};
